<app-navbar></app-navbar>

<router-outlet></router-outlet>

<app-footer1></app-footer1>

<!-- Sticky "For Business" Button -->
<button
  class="for-business-button"
  (click)="navigateToBusiness()"
  type="button"
  aria-label="Navigate to jujuja.com for business"
>
  <i class="fas fa-business-time"></i>
  <span class="for-business-text">For Business</span>
</button>

<!-- NgBootstrap Toast Container -->
<app-toast-container></app-toast-container>
